/**
 * <s-scroll-row> — Horizontal product row with previous/next buttons.
 * Children: [data-scroll-track] (the overflow-x scroller), [data-scroll-prev],
 * [data-scroll-next]. Buttons scroll by most of a view and disable at the ends.
 */
class SScrollRow extends HTMLElement {
  #controller = null;

  connectedCallback() {
    const track = this.querySelector('[data-scroll-track]');
    const prev = this.querySelector('[data-scroll-prev]');
    const next = this.querySelector('[data-scroll-next]');
    if (!track) return;
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    const step = () => Math.max(track.clientWidth * 0.8, 200);
    const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    const dir = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      const pos = Math.abs(track.scrollLeft);
      if (prev) prev.disabled = pos <= 2;
      if (next) next.disabled = pos >= max;
    };
    prev?.addEventListener('click', () => track.scrollBy({ left: -step() * dir, behavior }), { signal });
    next?.addEventListener('click', () => track.scrollBy({ left: step() * dir, behavior }), { signal });
    track.addEventListener('scroll', update, { signal, passive: true });
    window.addEventListener('resize', update, { signal });
    update();
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }
}

if (!customElements.get('s-scroll-row')) customElements.define('s-scroll-row', SScrollRow);
